<micro-lookup domain="access" obj="saAccessCategories" url="/access/categories" [key]="categoryId" [link]="link"></micro-lookup>
